// extracted by mini-css-extract-plugin
export var askAiIcon = "_ky-9";
export var container = "_ky-0";
export var groupSeparator = "_ky-a";
export var highlight = "_ky-4";
export var resultIcon = "_ky-5";
export var resultItem = "_ky-7";
export var resultSubtitle = "_ky-3";
export var resultTitle = "_ky-2";
export var resultsList = "_ky-1";
export var searchGroup = "_ky-6";
export var selected = "_ky-8";